/* eslint-disable jsx-a11y/media-has-caption */
/*
 TODO: update eslint-plugin-jsx-a11y to 6.0.4, when available
 - will have fix to read muted attribute correctly.
*/
import React from 'react';
import PropTypes from 'prop-types';

import { preloadImages, preloadVideos } from '../utilities/preloadMedia';

const MAX_STEPS = 4;

class IntroModal extends React.Component {
  static defaultProps = {
    onSubmit: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };

    this.getStepContent = this.getStepContent.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
  }

  componentDidMount() {
    preloadVideos(['/videos/Pay1.mp4', '/videos/Pay2.mp4', '/videos/Pay3.mp4']);
    preloadImages(['/images/banner-image.png']);
  }

  getStepContent() {
    const { step } = this.state;
    const actions = (
      <div className="actions">
        {step === 1 ? (
          <button className="btn" name="next" onClick={this.nextStep}>
            Let&apos;s Begin
          </button>
        ) : null}
        {step > 1 ? (
          <button className="btn" name="back" onClick={this.previousStep}>
            Back
          </button>
        ) : null}
        {step > 1 && step < MAX_STEPS ? (
          <button className="btn" name="next" onClick={this.nextStep}>
            Next
          </button>
        ) : null}
        {step === MAX_STEPS ? (
          <button className="btn" name="finish" onClick={this.props.onSubmit}>
            Got It!
          </button>
        ) : null}
      </div>
    );

    switch (step) {
      case 2:
        return (
          <div>
            <div className="media">
              <video muted src="/videos/Pay1.mp4" id="video1" autoPlay loop>
                <img src="/images/banner-image.png" className="img-responsive" alt="" title="" />
              </video>
            </div>
            <p>
              Tabby Pay is a smart contract interface that allows you to{' '}
              <span>send Ether or ERC20 tokens with peace of mind</span>.
            </p>
            {actions}
          </div>
        );
      case 3:
        return (
          <div>
            <div className="media">
              <video muted src="/videos/Pay2.mp4" id="video1" autoPlay loop>
                <img src="/images/banner-image.png" className="img-responsive" alt="" title="" />
              </video>
            </div>
            <p>
              We <span>verify the recipient</span> when they use our platform to accept the Ether or
              tokens.
            </p>
            {actions}
          </div>
        );
      case 4:
        return (
          <div>
            <div className="media">
              <video muted src="/videos/Pay3.mp4" id="video1" autoPlay loop>
                <img src="/images/banner-image.png" className="img-responsive" alt="" title="" />
              </video>
            </div>
            <p>
              If you send Ether or tokens to the wrong wallet, you&apos;re able to{' '}
              <span>cancel the payment</span> and your funds will be returned to your wallet.
            </p>
            {actions}
          </div>
        );
      default:
        return (
          <div>
            <h2>Welcome</h2>
            <p>
              Tabby Pay is a smart contract interface that allows you to send Ether or ERC20 tokens
              that <span>can be cancelled</span>.
            </p>
            {actions}
          </div>
        );
    }
  }

  nextStep() {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  }

  previousStep() {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  }

  render() {
    return <div className="intro-modal">{this.getStepContent()}</div>;
  }
}

IntroModal.propTypes = {
  onSubmit: PropTypes.func,
};

export default IntroModal;



// WEBPACK FOOTER //
// ./src/components/IntroModal.js